import { Component, OnInit } from '@angular/core';

import { SubcategoriaService } from '../../services/subcategoria.service';
import { Subcategoria } from '../../model/subcategoria';
import { ConsorciosService } from '../../services/consorcios.service';
import { Consorcio } from '../../model/consorcio';
import { CategoriaService } from '../../services/categoria.service';
import { Categoria } from '../../model/categoria';


@Component({
  selector: 'app-subcategoria-articulo-list',
  templateUrl: './subcategoria-articulo-list.component.html',
  styleUrls: ['./subcategoria-articulo-list.component.css']
})
export class SubcategoriaArticuloListComponent implements OnInit {

  public modoEdicion: boolean = false;

  public consorcio: Consorcio;
  public consorcios: Consorcio[];
public filtro:string;
  public categoria: string;
  public categorias: Categoria[];

  public subCategorias: Subcategoria[];
  public subCategoriaSeleccionada: Subcategoria;

  public query: any;

  constructor(
    private _subCategoriaService: SubcategoriaService,
    private _categoriaService: CategoriaService,
    private _consorcioService: ConsorciosService
  ) { }

  ngOnInit() {
    this.filtro = "";
    this.subCategorias = [];
     if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.consorcio = null;
    this.categoria = null;
    this.subCategoriaSeleccionada = new Subcategoria();
    this.cargarConsorcios();
  }

  cargarConsorcios() {
    this.query = { "email": sessionStorage.getItem("login") };

    this._consorcioService.getConsorciosUsuario(this.query)
      .subscribe(
      data => { this.consorcios = data; },
      err => {
        console.log(err);
      });
  }

  cargarCategorias() {
    if (this.consorcio === null) {
      return;
    }
    this._categoriaService.getCategorias(this.consorcio)
      .subscribe(
      data => this.categorias = data,
      err => {
        console.clear();
        console.log(err._body);
      });
    this.cargarSubCategorias();
  }

  cargarSubCategorias() {
    if (this.consorcio === null) {
      return;
    }
    this.query = {
      codigoConsorcio: this.consorcio.codigoConsorcio,
      codigoCategoria: this.categoria !== "null" ? this.categoria : null
    };
    this._subCategoriaService.getSubcategorias(this.query)
      .subscribe(
      data => this.subCategorias = data,
      err => {
        console.clear();
        console.log(err._body);
      });
  }

  agregarRegistro() {
    if (this.consorcio === null || this.categoria === null) {
      return;
    }
    this.subCategoriaSeleccionada = new Subcategoria();
    this.modoEdicion = true;
  }


  regresar() {
    this.modoEdicion = false;
    this.cargarSubCategorias();
  }


  editarRegistro(subcategoria: Subcategoria) {
    this.subCategoriaSeleccionada = subcategoria;
    this.modoEdicion = true;
  }


}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/subcategoria-articulo-list/subcategoria-articulo-list.component.ts